/**
 * Set domain paths and prefix to dataservice to infer
 * possible options when creating a request object
 * @returns domain specific createRequest function
 *
 * @example
 * export const createFinanceSepaRequest = createRequestHelper<
 *   paths, // imported from generated.ts in "types" folder
 *   '/financesepa'
 * >();
 */
// TODO: also pass TResponseCode, TContentType
export const createRequestHelper = () => ({ method, ...rest }) => ({
    method: String(method).toUpperCase(),
    ...rest,
});
